import { render, staticRenderFns } from "./SelectPpaColumns.vue?vue&type=template&id=07294714&"
import script from "./SelectPpaColumns.vue?vue&type=script&lang=js&"
export * from "./SelectPpaColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports